import React from 'react';
import { NextPage } from 'next';
import {
  getAllDocuments,
  getDocumentFromSlug,
} from '../../lib/markdown/template-markdown';
import convertMarkdown from '../../lib/markdown/convert-markdown';
import { LEGAL_DIRECTORY, LegalDocument } from '../../lib/markdown/types/legal';
import { useRouter } from 'next/router';
import ErrorPage from 'next/error';
import Layout from '../../components/layout';
import LegalContainer from '../../components/legal-container';
import GenericContainer from '../../components/@container/generic-container';

interface LegalProps {
  document: LegalDocument;
}

interface StaticParams {
  params: {
    slug: string;
  };
}

const LegalPage: NextPage<LegalProps> = ({ document }) => {
  const router = useRouter();

  if (!router.isFallback && !document.slug) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <Layout title={document.title}>
      <GenericContainer
        title={document.title}
        subtitle={`Last updated ${document.effectiveDate}`}
        breadcrumb={{ url: '/', text: 'Back to Home' }}
      >
        <div className="content">
          <LegalContainer content={document.content} />
        </div>
      </GenericContainer>
      {/* language=CSS */}
      <style jsx>
        {`
          .content :global(td) {
            padding: 5px;
          }
        `}
      </style>
    </Layout>
  );
};

export const getStaticProps = async ({ params }: StaticParams) => {
  const document = getDocumentFromSlug(LEGAL_DIRECTORY, params.slug, [
    'slug',
    'title',
    'effectiveDate',
    'content',
  ]);

  const content = await convertMarkdown(document.content || '');

  return {
    props: {
      document: {
        ...document,
        content,
      },
    },
  };
};

export const getStaticPaths = async () => {
  const documents = getAllDocuments(LEGAL_DIRECTORY, ['slug']);

  return {
    paths: documents.map((document) => {
      return {
        params: {
          slug: document.slug,
        },
      };
    }),
    fallback: false,
  };
};

export default LegalPage;
